import { render } from "./nav-trigger.vue?vue&type=template&id=715d6613"
import script from "./nav-trigger.vue?vue&type=script&lang=js"
export * from "./nav-trigger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__